import { z } from 'zod';

import { MILEAGE_UNIT } from '../../../../types';

export const valuationSchema = z.object({
  registration: z.string().min(1, 'Registration Required'),
  mileage: z.string().min(1, 'Mileage is required'),
  mileageType: z.nativeEnum(MILEAGE_UNIT),
});

export type ValuationFormValues = z.infer<typeof valuationSchema>;
